import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

function getGalleryLink(rootState) {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.yola-template-gallery.url');
  }

  return get(cfg, 'common.yola-template-gallery.wl_url');
}

export default getGalleryLink;
